/**
 * Background variant type
 *
 * @components
 *  - ghs-hero-banner
 *  - ghs-hero-provider
 */
export type BackgroundVariant =
  | 'green-gradient'
  | 'blue-gradient'
  | 'image-gradient'
  | 'light-blue';

export const backgroundVariantOptions: BackgroundVariant[] = [
  'green-gradient',
  'blue-gradient',
  'image-gradient',
  'light-blue',
];

/**
 * Horizontal Aligntment variant type
 *
 * @components
 *  - ghs-hero-banner
 */
export type HorizontalAlignmentVariant = 'left-align' | 'right-align';

export const horizontalAlignmentVariantOptions: HorizontalAlignmentVariant[] = [
  'left-align',
  'right-align',
];
